import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDraggable]'
})
export class DraggableDirective {
    private dragging = false;
    private offsetX = 0;
    private offsetY = 0;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent): void {
        this.dragging = true;
        this.offsetX = event.clientX - this.el.nativeElement.getBoundingClientRect().left;
        this.offsetY = event.clientY - this.el.nativeElement.getBoundingClientRect().top;
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
    }

    private onMouseMove = (event: MouseEvent): void => {

        if (this.dragging) {
            const left = event.clientX - this.offsetX;
            const top = event.clientY - this.offsetY;
            this.el.nativeElement.style.left = `${left}px`;
            this.el.nativeElement.style.top = `${top}px`;
        }
    };

    private onMouseUp = (): void => {
        this.dragging = false;
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    };
}
